import React, { useState, useEffect } from "react";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../../../config/firebase";
import { uploadToCloudinary } from "../utils/cloudinaryUpload";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./UploadBlog.css";

function UploadBlog() {
  const [form, setForm] = useState({
    title: "",
    author: "",
    tags: "",
  });
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const slug = form.title.toLowerCase().replace(/\s+/g, "-");
      const imageUrl = image ? await uploadToCloudinary(image) : "";

      await addDoc(collection(db, "blogs"), {
        title: form.title,
        slug,
        author: form.author,
        tags: form.tags.split(",").map((t) => t.trim()),
        description,
        image: imageUrl,
        postDate: new Date(),
      });

      alert("✅ Blog added successfully!");
      setForm({ title: "", author: "", tags: "" });
  setImage(null);
  setPreview(null);
      setDescription("");
    } catch (err) {
      console.error(err);
      alert("⚠️ Error adding blog!");
    }

    setLoading(false);
  };

  useEffect(() => {
    // create preview when image changes
    if (!image) {
      setPreview(null);
      return;
    }
    const objectUrl = URL.createObjectURL(image);
    setPreview(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [image]);

  return (
    <div className="upload-blog-container">
      <div className="upload-card">
        <h2>Add New Blog</h2>
        <form onSubmit={handleSubmit} className="upload-form">
          <div className="form-row">
            <label className="form-label">Title</label>
            <input
              type="text"
              placeholder="Blog Title"
              value={form.title}
              onChange={(e) => setForm({ ...form, title: e.target.value })}
              required
              maxLength={120}
            />
          </div>

          <div className="form-row two-col">
            <div>
              <label className="form-label">Author</label>
              <input
                type="text"
                placeholder="Author Name"
                value={form.author}
                onChange={(e) => setForm({ ...form, author: e.target.value })}
              />
            </div>
            <div>
              <label className="form-label">Tags</label>
              <input
                type="text"
                placeholder="Tags (comma separated)"
                value={form.tags}
                onChange={(e) => setForm({ ...form, tags: e.target.value })}
              />
            </div>
          </div>

          <div className="form-row">
            <label className="form-label">Description</label>
            <ReactQuill
              theme="snow"
              value={description}
              onChange={setDescription}
              modules={{
                toolbar: [
                  ["bold", "italic", "underline"],
                  [{ list: "ordered" }, { list: "bullet" }],
                  [{ align: [] }],
                  ["clean"],
                ],
              }}
            />
          </div>

          <div className="form-row image-row">
            <div>
              <label className="form-label">Feature Image</label>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => setImage(e.target.files[0])}
              />
            </div>
            <div className="image-preview">
              {preview ? (
                <img src={preview} alt="preview" />
              ) : (
                <div className="placeholder">No image selected</div>
              )}
            </div>
          </div>

          <div className="form-actions">
            <button className="btn primary" type="submit" disabled={loading}>
              {loading ? "Uploading..." : "Add Blog"}
            </button>
            <button
              type="button"
              className="btn ghost"
              onClick={() => {
                setForm({ title: "", author: "", tags: "" });
                setImage(null);
                setPreview(null);
                setDescription("");
              }}
            >
              Reset
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default UploadBlog;